import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { slugify } from '../../util';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.logged_in != this.props.logged_in) {
            //user logs out on /vip/transits/* page
            if (nextProps.logged_in == false && document.location.href.match(/vip\/transits/)) {
                document.location.href = '/daily-horoscope';
                return false;
            }
        }

        if (nextProps.transits != this.props.transits) {
            return true;
        }

        return false;
    }

    render({ date }) {
        return (
            <vip-transits-list date={date}>
                {this.renderTransits()}
            </vip-transits-list>
        );
    }

    renderTransits = () => {
        if (this.props.transits) {
            return Object.keys(this.props.transits).map(key => {
                const transit = this.props.transits[key];
                return (
                    <a href={`/vip/transits/${this.props.date}/${slugify(transit.header)}`}>
                        <h5><span className='symbol'>{transit.symbol_header}</span> {transit.title}</h5>
                        <h2>{transit.header}</h2>
                        {this.renderTransitLabel(transit)}
                    </a>
                );
            });
        }

        return null;
    }

    renderTransitLabel = (transit) => {
        if (transit.label) {
            return (
                <span className={`transit-label ${slugify(transit.label)}`}>
                    {transit.label}
                </span>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    transits: state.transits,
    logged_in: state.user && state.user.logged_in,
});

export default connect(mapStateToProps)(Component);